import { createContext } from "react";

interface ServerData {
  recaptchaSiteKey: string | undefined;
  csrfToken: string | undefined;
  acceptedTerms: boolean;
  signedIn: boolean;
}

const ServerDataContext = createContext<ServerData>({
  recaptchaSiteKey: "",
  csrfToken: "",
  acceptedTerms: false,
  signedIn: false,
});

export { ServerDataContext };
export type { ServerData };
